var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmptyState = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "167px",
    height: "88px",
    viewBox: "0 0 167 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1150,
    height: 731
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1135,
    height: 824,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-0.9%",
    width: "102.0%",
    height: "102.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.4-List-create-empty",
    transform: "translate(-779.000000, -449.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 159.5,
    width: 1441,
    height: 865
  }), /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(291.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#DFE2E5",
    x: -0.5,
    y: -0.5,
    width: 1151,
    height: 732
  })), /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(290.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(684.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NoSearchResult",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207,65 C210.865993,65 214,68.1340068 214,72 C214,75.8659932 210.865993,79 207,79 L167,79 C170.865993,79 174,82.1340068 174,86 C174,89.8659932 170.865993,93 167,93 L189,93 C192.865993,93 196,96.1340068 196,100 C196,103.865993 192.865993,107 189,107 L178.826087,107 C173.951574,107 170,110.134007 170,114 C170,116.577329 172,118.910662 176,121 C179.865993,121 183,124.134007 183,128 C183,131.865993 179.865993,135 176,135 L93,135 C89.1340068,135 86,131.865993 86,128 C86,124.134007 89.1340068,121 93,121 L54,121 C50.1340068,121 47,117.865993 47,114 C47,110.134007 50.1340068,107 54,107 L94,107 C97.8659932,107 101,103.865993 101,100 C101,96.1340068 97.8659932,93 94,93 L69,93 C65.1340068,93 62,89.8659932 62,86 C62,82.1340068 65.1340068,79 69,79 L109,79 C105.134007,79 102,75.8659932 102,72 C102,68.1340068 105.134007,65 109,65 L207,65 Z M207,93 C210.865993,93 214,96.1340068 214,100 C214,103.865993 210.865993,107 207,107 C203.134007,107 200,103.865993 200,100 C200,96.1340068 203.134007,93 207,93 Z",
    id: "Background",
    fillOpacity: 0.25,
    fill: "#DFE2E5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(87.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    fillOpacity: 0.5,
    fill: "#FFFFFF",
    cx: 33.5,
    cy: 33.5,
    r: 33.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1320801,59.4938965 C29.890814,59.818529 31.6801207,59.9872302 33.5,60 C48.1355459,60 60,48.1355459 60,33.5 C60,18.8644541 48.1355459,7 33.5,7 C29.7403616,7 26.1635859,7.78292845 22.9238202,9.19463803 C17.293841,11.6478697 12.681584,15.9999304 9.89598776,21.4418818 C8.04450607,25.0589434 7,29.157493 7,33.5 C7,37.4400034 7.85985082,41.1791779 9.40213862,44.5401097 C10.5032232,46.9395777 11.9521427,49.1462571 13.6843385,51.0955896",
    id: "Oval",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7974263,54.0747242 C18.9455459,55.8207047 21.3723828,57.2370261 24.0008698,58.2466213",
    id: "Oval",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,15 C32.2773142,15 30.6081757,15.2292632 29.0214315,15.6589426 C20.9428274,17.8465728 15,25.2292755 15,34",
    id: "Oval",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61,
    y1: 60,
    x2: 67,
    y2: 66,
    id: "Path-4",
    stroke: "#DFE2E5",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8844176,65.0302921 C71.9380604,64.0839349 70.6977076,63.6107563 69.4573549,63.6107563 C68.2170021,63.6107563 66.9766494,64.0839349 66.0302921,65.0302921 C65.0839349,65.9766494 64.6107563,67.2170021 64.6107563,68.4573549 C64.6107563,69.6977076 65.0839349,70.9380604 66.0302921,71.8844176 L77.1155824,82.9697079 C78.0619396,83.9160651 79.3022924,84.3892437 80.5426451,84.3892437 C81.7829979,84.3892437 83.0233506,83.9160651 83.9697079,82.9697079 C84.9160651,82.0233506 85.3892437,80.7829979 85.3892437,79.5426451 C85.3892437,78.3022924 84.9160651,77.0619396 83.9697079,76.1155824 L72.8844176,65.0302921 Z",
    id: "Rectangle",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    fillOpacity: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 67,
    x2: 82,
    y2: 78,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,92 L163.324219,92 M187.5,92 L185.278809,92 M174.175781,99.7773438 L166,99.7773438",
    id: "Line-8",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,113 L62.3242188,113 M56.5,113 L52.2788086,113 M84.1757812,121.777344 L76,121.777344",
    id: "Line-8",
    stroke: "#DFE2E5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyState, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyState.4c800c2a.svg";
export { ForwardRef as ReactComponent };